import { motion } from "framer-motion";
import { Target, Layers, Zap, TrendingUp } from "lucide-react";

const reasons = [
  { icon: Target, text: "We focus on bookings and revenue—not just leads" },
  { icon: Layers, text: "We build systems, not one-off campaigns" },
  { icon: Zap, text: "We prioritize speed-to-lead and conversion" },
  { icon: TrendingUp, text: "We help you get more from your existing traffic" },
];

export const WhyChooseUs = () => {
  return (
    <section className="py-20 px-4 bg-muted/30">
      <div className="max-w-4xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-3xl md:text-4xl font-bold mb-10 text-foreground text-center"
        >
          Why Businesses Choose Us
        </motion.h2>
        <div className="grid sm:grid-cols-2 gap-5">
          {reasons.map((item, i) => (
            <motion.div
              key={item.text}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="flex items-center gap-4 p-5 rounded-xl border border-border bg-card"
            >
              <div className="p-3 rounded-lg bg-primary/10 shrink-0">
                <item.icon className="h-5 w-5 text-primary" />
              </div>
              <span className="text-foreground font-medium">{item.text}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
